/**
 * @desc SPU-导出
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.productMaster.exportExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/exportExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
